
import { GameState } from '../GameContextTypes';

export const completeChallenge = (state: GameState): GameState => {
  if (!state.currentChallenge) return state;
  
  let updatedAchievements = [...state.achievements];
  
  // Award achievement for completing a difficult challenge
  if (state.currentChallenge.difficulty >= 4) {
    updatedAchievements.push(`Overcame ${state.currentChallenge.title} challenge`);
  }
  
  return {
    ...state,
    currentChallenge: null,
    achievements: updatedAchievements
  };
};
